"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _appActions = require("../appActions");
var _recommendationActions = require("./recommendationActions");
var _utils = require("../../utils/utils");
var _questionnaireActions = require("../questionnaire/questionnaireActions");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  isRecommendationFetched: false,
  recommendationRawData: [],
  handsets: [],
  plans: [],
  broadbands: [],
  businessSolutions: [],
  selectedHandsetId: '',
  selectedPlanId: '',
  selectedBroadbandId: '',
  selectedBusinessSolutionsId: '',
  steps: [],
  currentStep: 1
};
var recommendationReducer = function recommendationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case _recommendationActions.SET_RAW_RECOMMENDATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        recommendationRawData: payload.recommendationResponse
      });
    case _recommendationActions.SET_RECOMMENDATION:
      {
        var _state$handsets, _handsetPayload$find, _plans$find, _broadbands$find, _businessSolutions$fi;
        var _payload$recommendati = payload.recommendationData,
          handsets = _payload$recommendati.handsets,
          plans = _payload$recommendati.plans,
          broadbands = _payload$recommendati.broadbands,
          businessSolutions = _payload$recommendati.businessSolutions;
        var stateHandSetIds = (_state$handsets = state.handsets) === null || _state$handsets === void 0 ? void 0 : _state$handsets.map(function (handset) {
          return handset.productId;
        });
        var handsetIds = handsets === null || handsets === void 0 ? void 0 : handsets.map(function (handset) {
          return handset.productId;
        });
        var shouldUseStateHandsets = stateHandSetIds.length === handsetIds.length && stateHandSetIds.every(function (element) {
          return handsetIds.includes(element);
        });
        var handsetPayload = shouldUseStateHandsets ? state.handsets : handsets;
        var selectedHandsetId = handsetPayload === null || handsetPayload === void 0 ? void 0 : (_handsetPayload$find = handsetPayload.find(function (handset) {
          return handset.tier === 'recommended';
        })) === null || _handsetPayload$find === void 0 ? void 0 : _handsetPayload$find.productId;
        var selectedPlanId = plans === null || plans === void 0 ? void 0 : (_plans$find = plans.find(function (handset) {
          return handset.tier === 'recommended';
        })) === null || _plans$find === void 0 ? void 0 : _plans$find.productId;
        var selectedBroadbandId = broadbands === null || broadbands === void 0 ? void 0 : (_broadbands$find = broadbands.find(function (broadband) {
          return broadband.tier === 'recommended';
        })) === null || _broadbands$find === void 0 ? void 0 : _broadbands$find.productId;
        var selectedBusinessSolutionsId = businessSolutions === null || businessSolutions === void 0 ? void 0 : (_businessSolutions$fi = businessSolutions.find(function (broadband) {
          return broadband.tier === 'recommended';
        })) === null || _businessSolutions$fi === void 0 ? void 0 : _businessSolutions$fi.productId;
        return _objectSpread(_objectSpread({}, state), {}, {
          handsets: handsetPayload,
          plans: plans,
          broadbands: broadbands,
          businessSolutions: businessSolutions,
          selectedHandsetId: state.selectedHandsetId || selectedHandsetId || '',
          selectedPlanId: state.selectedPlanId || selectedPlanId || '',
          selectedBroadbandId: state.selectedBroadbandId || selectedBroadbandId || '',
          selectedBusinessSolutionsId: state.selectedBusinessSolutionsId || selectedBusinessSolutionsId || ''
        });
      }
    case _recommendationActions.UNSET_RECOMMENDATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        handsets: initialState.handsets,
        plans: initialState.plans,
        broadbands: initialState.broadbands,
        businessSolutions: initialState.businessSolutions,
        selectedHandsetId: null,
        selectedPlanId: null,
        selectedBroadbandId: null
      });
    case _questionnaireActions.RESET_BUDGET_AND_RECOMMENDATION:
      return (0, _utils.clone)(initialState);
    case _recommendationActions.UPDATE_SELECTED_HANDSET:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedHandsetId: payload.productId
        });
      }
    case _recommendationActions.UPDATE_SELECTED_VARIANT:
      {
        var _handsets = state.handsets.map(function (handset) {
          if (handset.productId === payload.productId) {
            var selectedVariant = handset.variants.find(function (variant) {
              return variant.variantId === payload.variantId;
            });
            return _objectSpread(_objectSpread({}, handset), {}, {
              selectedVariant: selectedVariant
            });
          }
          return handset;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          handsets: _handsets
        });
      }
    case _recommendationActions.UPDATE_SELECTED_PLAN:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedPlanId: payload.productId
        });
      }
    case _recommendationActions.UPDATE_SELECTED_BROADBAND:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedBroadbandId: payload.productId
        });
      }
    case _recommendationActions.UPDATE_SELECTED_BUSINESS_SOLUTION:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedBusinessSolutionsId: payload.productId
        });
      }
    case _appActions.INJECT_STATE:
      return _objectSpread(_objectSpread({}, state), payload.recommendation);
    case _recommendationActions.SET_STEPS:
      return _objectSpread(_objectSpread({}, state), {}, {
        steps: payload.steps
      });
    case _recommendationActions.GO_TO_NEXT_STEP:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentStep: state.currentStep + 1
      });
    case _recommendationActions.GO_TO_PREVIOUS_STEP:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentStep: state.currentStep - 1
      });
    case _recommendationActions.FETCH_RECOMMENDATION_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isRecommendationFetched: true
      });
    default:
      return state;
  }
};
var _default = recommendationReducer;
exports.default = _default;